import {
  createRouter,
} from "@tanstack/react-router";
import { RouteErrorFallback } from "./lib/RouteErrorFallback";
import { routeTree } from "./routeTree.gen";
import { queryClient } from "./lib/queryClient";
import { installTakeoverOriginTracker } from "./lib/takeoverOrigin";

/**
 * Singleton router instance.
 *
 * `defaultPreload: 'intent'` triggers loader prefetch on link hover/focus —
 * sub-100ms tab switches across the workspace without speculative full
 * navigations. The route tree itself is auto-generated by
 * `@tanstack/router-plugin` from `src/routes/**` (see `vite.config.ts`); do
 * NOT edit `routeTree.gen.ts` by hand.
 */
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  // `0` is the RECOMMENDED setting when loaders delegate to TanStack Query:
  // the router never caches loader data itself, so Query's own `staleTime`
  // (60s, see `lib/queryClient`) is the single source of freshness truth.
  // Hover/focus preload runs the loader → `ensureQueryData` warms the Query
  // cache; the click then paints from that cache.
  defaultPreloadStaleTime: 0,
  // Router-level context threaded into every `loader` / `beforeLoad`.
  context: { queryClient },
  defaultErrorComponent: RouteErrorFallback,
});

// Remember the workspace surface the user is on, so the Settings /
// Integrations takeovers can return exactly there — the avatar drawer
// navigates with ``replace: true``, which leaves no usable history entry to
// pop (see ``lib/takeoverOrigin``).
installTakeoverOriginTracker(router);

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
